import React from "react"
import styles from "./ThreeDotsAnimation.module.scss"
import classNames from "classnames"

export const ThreeDotsAnimation: React.FC<{className?: string}> = ({className}) => {
    return (
        <div className={classNames(styles.wrapper, className)}>
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
        </div>
    )
}